// extracted by mini-css-extract-plugin
module.exports = {"AwesomeListMenu":"AwesomeListMenu_AwesomeListMenu__u0wy6"};